import { createDefaultDispatcher34z5li45gie67 as createDefaultDispatcher } from './CoroutineContext.mjs';
import { Unconfined_getInstance1ugsk82se1vaj as Unconfined_getInstance } from './Unconfined.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MainCoroutineDispatcher158x49bd8e9gp as MainCoroutineDispatcher } from './MainCoroutineDispatcher.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DispatchersClass;
function Dispatchers() {
  if (DispatchersClass === VOID) {
    class $ {
      constructor() {
        Dispatchers_instance = this;
        this.Default_1 = createDefaultDispatcher();
        this.Unconfined_1 = Unconfined_getInstance();
        this.mainDispatcher_1 = new (JsMainDispatcher())(this.Default_1, false);
        this.injectedMainDispatcher_1 = null;
      }
      get_Main_wo5vz6_k$() {
        var tmp0_elvis_lhs = this.injectedMainDispatcher_1;
        return tmp0_elvis_lhs == null ? this.mainDispatcher_1 : tmp0_elvis_lhs;
      }
    }
    initMetadataForObject($, 'Dispatchers');
    DispatchersClass = $;
  }
  return DispatchersClass;
}
var Dispatchers_instance;
function Dispatchers_getInstance() {
  if (Dispatchers_instance === VOID)
    new (Dispatchers())();
  return Dispatchers_instance;
}
var JsMainDispatcherClass;
function JsMainDispatcher() {
  if (JsMainDispatcherClass === VOID) {
    class $ extends MainCoroutineDispatcher() {
      constructor(delegate, invokeImmediately) {
        super();
        this.delegate_1 = delegate;
        this.invokeImmediately_1 = invokeImmediately;
        this.immediate_1 = this.invokeImmediately_1 ? this : new (JsMainDispatcher())(this.delegate_1, true);
      }
      get_immediate_r3y8eg_k$() {
        return this.immediate_1;
      }
      isDispatchNeeded_ft82v4_k$(context) {
        return !this.invokeImmediately_1;
      }
      dispatch_qa3n0o_k$(context, block) {
        return this.delegate_1.dispatch_qa3n0o_k$(context, block);
      }
      toString() {
        var tmp0_elvis_lhs = this.toStringInternalImpl_hcqz93_k$();
        return tmp0_elvis_lhs == null ? this.delegate_1.toString() : tmp0_elvis_lhs;
      }
    }
    initMetadataForClass($, 'JsMainDispatcher');
    JsMainDispatcherClass = $;
  }
  return JsMainDispatcherClass;
}
//region block: exports
export {
  Dispatchers_getInstance as Dispatchers_getInstance128lm494a5r5s,
};
//endregion

//# sourceMappingURL=Dispatchers.mjs.map
